<form [formGroup]="form">
  <ifc-base-filter-dialog [form]="form" (confirmed)="onConfirmed($event)">
    <ifb-business-advisor-input
      [fc]="form.get('fullName')"
      baseFilterItem
      [showAvatar]="false"
    ></ifb-business-advisor-input>
    <ifb-advisor-email-input [fc]="form.get('email')" baseFilterItem></ifb-advisor-email-input>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Unique ID</mat-label>
      <input matInput name="uniqueId" formControlName="uniqueId" type="text" placeholder="Unique ID" />
      <button
        type="button"
        *ngIf="form.controls.uniqueId.value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.controls.uniqueId.setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Status</mat-label>
      <mat-select matInput formControlName="active" placeholder="Status">
        <mat-option>All</mat-option>
        <mat-option value="true">Active</mat-option>
        <mat-option value="false">Inactive</mat-option>
      </mat-select>
    </mat-form-field>
  </ifc-base-filter-dialog>
</form>
